import get from 'lodash/get';

export default (state: object): string | undefined =>
  get(state, 'page.data.site.font');
